<script setup>
import { ref, onMounted } from 'vue'
import AppNavbar from '~/components/AppNavbar.vue'
import AppToast from '~/components/AppToast.vue'
import AppErrorModal from '~/components/AppErrorModal.vue'
import AppFooter from '~/components/AppFooter.vue'
import ImpersonationBanner from '~/components/ImpersonationBanner.vue'
import { useImpersonation } from '~/composables/useImpersonation.js'

const { fileInputRef, onFileChange } = useUpload()
const { offsetClass } = useImpersonation()
const fileInput = ref(null)
onMounted(() => { fileInputRef.value = fileInput.value })
</script>

<template>
  <div :class="offsetClass">
    <ClientOnly><ImpersonationBanner /></ClientOnly>
    <AppNavbar />
    <slot />
    <AppFooter />
    <AppToast />
    <AppErrorModal />
    <ClientOnly><CookiesBanner /></ClientOnly>
    <input ref="fileInput" type="file" accept="image/*" multiple hidden @change="onFileChange" />
  </div>
</template>
